import React, { useEffect, useState } from 'react';
import UserDashboard from './UserDashboard';
import attendanceAPI from '../api/attendanceAPI';
import Swal from 'sweetalert2';

const TeamAttendance = () => {
  const [records, setRecords] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const formatDate = (isoDate) => {
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
  };

 useEffect(() => {
  attendanceAPI
    .get('/')
    .then((res) => {
      const allRecords = res.data;
      const worker = JSON.parse(localStorage.getItem("worker"));

      let filtered = allRecords;

      if (worker?.role === "TL") {
        // TL → only Developers from the same company
        filtered = allRecords.filter(
          (rec) => rec.role === "Developer" && rec.company === worker.company
        );
      } else if (worker?.role === "Developer") {
        // Developer → only their own records
        filtered = allRecords.filter(
          (rec) => rec.username === worker.username
        );
      }
      // HR → no filter

      setRecords(filtered);
    })
    .catch((err) => console.log(err));
}, []);



  const filteredRecords = records.filter((rec) => {
    const search = searchQuery.toLowerCase();
    return (
      rec.username?.toLowerCase().includes(search) ||
      rec.date?.includes(searchQuery) ||
      rec.workMode?.toLowerCase().includes(search) ||
      rec.status?.toLowerCase().includes(search)
    );
  });

  const downloadCSV = () => {
  const headers = [
    "Date",
    "Name",
    "Company",
    "Role",
    "Work Mode",
    "Login Time(s)",
    "Logout Time(s)",
    "Total Hours",
    "Overtime",
    "Status",
  ];

  const rows = filteredRecords.flatMap((rec) => {
    if (rec.sessions && rec.sessions.length > 0) {
      // 🟢 Multiple sessions → one row per session
      return rec.sessions.map((s) => [
        rec.date ? `'${rec.date}` : "N/A",
        rec.username,
        rec.company || "N/A",
        rec.role,
        rec.workMode || "N/A",
        s.loginTime || "N/A",
        s.logoutTime || "N/A",
        s.totalHours || "N/A",
        s.overtime || "N/A",
        rec.status,
      ]);
    } else {
      // 🔴 No sessions → fallback
      return [
        [
          rec.date ? `'${rec.date}` : "N/A",
          rec.username,
          rec.company || "N/A",
          rec.role,
          rec.workMode || "N/A",
          "N/A",
          "N/A",
          rec.totalHours || "N/A",
          rec.overtime || "N/A",
          rec.status,
        ],
      ];
    }
  });

  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.map((v) => `"${v}"`).join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "attendance_report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  return (
    <div>
      <UserDashboard />
      <div className="min-h-screen bg-gradient-to-br from-purple-100 to-pink-100 p-8 pt-20">
        <h2 className="text-3xl font-bold font-mono text-purple-700 mb-2 mt-4 text-center">
  Attendance Report{" "}
  {JSON.parse(localStorage.getItem("worker"))?.role === "TL" &&
    `- ${JSON.parse(localStorage.getItem("worker")).team} Team`}
</h2>


        {/* Search and Download Row */}
        <div className="bg-white shadow-md rounded-xl p-4 mb-6">
        <div className="max-w-8xl mx-auto mb-4 flex flex-col sm:flex-row justify-between items-center gap-4">
          <input
            type="text"
            placeholder="Search by name, date, work mode, or status..."
            className="px-4 py-2 border rounded-lg w-1/3 "
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          
          <button
            onClick={() => {
              Swal.fire({
                title: 'Download Report?',
                text: 'Do you want to download this attendance report?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#6b21a8', // purple-800
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
              }).then((result) => {
                if (result.isConfirmed) {
                  downloadCSV();
                }
              });
            }}
            className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700"
          >
            Download CSV
          </button>
        </div>

        <div className="md:max-h-[420px] max-h-[500px] overflow-auto">
          <table className="min-w-full table-auto">
            <thead className="bg-purple-100 text-purple-700">
              <tr>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Date</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Profile</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Name</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Company</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Role</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Work Mode</th>
                {/* <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Latitude</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Longitude</th> */}
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Login Time</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Logout Time</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Total Hours</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Overtime</th>
                <th className="py-3 px-4 sticky top-0 z-10 bg-purple-100">Status</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {filteredRecords.map((rec, idx) => (
                <tr key={idx} className="border-t hover:bg-purple-50 transition">
                  <td className="py-3 px-4">{new Date(rec.date).toLocaleDateString('en-GB')}</td>
                  <td className="py-3 px-4">
                     <img
                      src={rec.workerId.profileImage?.replace(/\\/g, '/')}
                      alt="profile"
                      className="w-10 h-10 rounded-full object-cover"
                    />
                  </td>
                  <td className="py-3 px-4">{rec.username}</td>
                  <td className="py-3 px-4">{rec.company || '--'}</td>
                  <td className="py-3 px-4">{rec.role}</td>
                  <td className="py-3 px-4">{rec.workMode || '--'}</td>
                  {/* <td className="py-3 px-4">{typeof rec.lat === 'number' ? rec.lat.toFixed(5) : '--'}</td>
                  <td className="py-3 px-4">{typeof rec.lng === 'number' ? rec.lng.toFixed(5) : '--'}</td> */}

                  <td className="py-3 px-4">
  {rec.sessions && rec.sessions.length > 0 ? (
    <ul>
      {rec.sessions.map((s, i) => (
        <li key={i}>{s.loginTime || '--'}</li>
      ))}
    </ul>
  ) : '--'}
</td>

{/* Logout Times */}
<td className="py-3 px-4">
  {rec.sessions && rec.sessions.length > 0 ? (
    <ul>
      {rec.sessions.map((s, i) => (
        <li key={i}>
          {s.logoutTime ? (
            s.logoutTime
          ) : (
            <button
              onClick={() => {
                Swal.fire({
                  title: 'Logout?',
                  text: `Do you want to logout ${rec.username}?`,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Yes, Logout'
                }).then((result) => {
                  if (result.isConfirmed) {
                    attendanceAPI
                      .post('/mark', { workerId: rec.workerId, action: 'logout' })
                      .then(() => {
                        Swal.fire('Success', `${rec.username} logged out.`, 'success');
                        // 🔄 Refresh attendance
                        attendanceAPI.get('/').then((res) => setRecords(res.data));
                      })
                      .catch((err) => {
                        Swal.fire('Error', 'Logout failed', 'error');
                        console.error(err);
                      });
                  }
                });
              }}
              className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 text-sm"
            >
              Logout
            </button>
          )}
        </li>
      ))}
    </ul>
  ) : (
    '--'
  )}
</td>

                  {/* <td className="py-3 px-4">{rec.loginTime || '--'}</td>
                  <td className="py-3 px-4">{rec.logoutTime || '--'}</td> */}
                  <td className="py-3 px-4">{rec.totalHours || '--'}</td>
                  <td className="py-3 px-4">{rec.overtime || '--'}</td>
                  <td
                    className={`py-3 px-4 font-semibold ${
                      rec.status === 'Present' ? 'text-green-600' : 'text-red-500'
                    }`}
                  >
                    {rec.status}
                  </td>
                </tr>
              ))}
              {filteredRecords.length === 0 && (
                <tr>
                  <td colSpan="12" className="text-center py-6 text-gray-500">
                    No attendance records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
};

export default TeamAttendance;
